module.exports = __webpack_public_path__ + "static/media/Brands_1.a32550b4.png";